import React from 'react'

const SecBanner = () => {
    return (
        <section>
            <div className="container">
                <div className="wrapper__banner-gamgam position-relative">
                    <div className="row">
                        <div className="col-md-6 z-2 text-center text-md-left">
                            <h2 className='semi-bold font__size--64 text__65-1024 text__65-md text__65-sm color__white mb-0'>Descarga ListoPago</h2>
                            <p className='medium font__size--16 text__12-1024 color__white my-4'>La app que convierte cada foto de comprobante en una transacción registrada en segundos.</p>
                            <div className="d-flex justify-content-center justify-content-md-start">
                                <a href="https://play.google.com/store/apps/details?id=com.listopago.app" target="_blank" rel="noopener noreferrer">
                                    <img src="./../images/safdd (2).png" alt="Descargar en Google Play" />
                                </a>
                            </div>
                        </div>
                    </div>
                    <img src="./../images/Co-workers-bro.png" className='images__banner-right' alt="" />
                </div>
            </div>
        </section>
    )
}

export default SecBanner